import { render } from "./Menu.vue?vue&type=template&id=e136fa8c&scoped=true"
import script from "./Menu.vue?vue&type=script&lang=js"
export * from "./Menu.vue?vue&type=script&lang=js"

import "./Menu.vue?vue&type=style&index=0&id=e136fa8c&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\frontend.avicola\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e136fa8c"]])

export default __exports__